export default __webpack_public_path__ + "static/media/05.d7c05243.svg";